import React from 'react';
import dot from '../images/dot.jpg'
import './CaltureContentsRightItem.css'

const classNames = require('classnames');

export default function CaltureContentsRightItem(props: {
    children: string,
    className?: any
}) {
    return (
        <div className={classNames('calture-contents-right-item', props.className)}>
            <img className='dot' src={dot} alt='dot'/>
            <p className='calture-contents-right-item-text'>
                {props.children}
            </p>
        </div>
    )
}